module.exports = __webpack_public_path__ + "static/media/markicon.2220dfd1.svg";